module.exports = __webpack_public_path__ + "static/img/icon15.f1d1528b.png";